import { render, staticRenderFns } from "./TagPantalla.vue?vue&type=template&id=60004075&scoped=true&"
import script from "./TagPantalla.vue?vue&type=script&lang=ts&"
export * from "./TagPantalla.vue?vue&type=script&lang=ts&"
import style0 from "./TagPantalla.vue?vue&type=style&index=0&id=60004075&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60004075",
  null
  
)

export default component.exports